import { render, staticRenderFns } from "./PzUpload.vue?vue&type=template&id=75fe5c71&scoped=true"
import script from "./PzUpload.vue?vue&type=script&lang=js"
export * from "./PzUpload.vue?vue&type=script&lang=js"
import style0 from "./PzUpload.vue?vue&type=style&index=0&id=75fe5c71&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fe5c71",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75fe5c71')) {
      api.createRecord('75fe5c71', component.options)
    } else {
      api.reload('75fe5c71', component.options)
    }
    module.hot.accept("./PzUpload.vue?vue&type=template&id=75fe5c71&scoped=true", function () {
      api.rerender('75fe5c71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/forms/Fields/PzUpload.vue"
export default component.exports